// shared.jsx — bits used by more than one Variant.
// FavoritesStrip + SunArc come from /tmp/handoff-fcc-weather/src/variants-ab.jsx.

import { WxIcon, Glyph } from '../icons.jsx';
import { getFavorites } from '../data-bridge.js';

export function FavoritesStrip({ brand, density, current, onPick, compact = false }) {
  const favorites = getFavorites();
  return (
    <div style={{
      display: 'flex', gap: 8, overflowX: 'auto', scrollSnapType: 'x mandatory',
      padding: `4px ${density.pad}px ${density.gap}px`, scrollbarWidth: 'none',
    }} className="wx-hide-scroll">
      {favorites.map((f) => {
        const active = f.id === current;
        return (
          <button key={f.id} onClick={() => onPick?.(f)} className="wx-tap" style={{
            flexShrink: 0, scrollSnapAlign: 'start', display: 'flex', alignItems: 'center', gap: 8,
            padding: compact ? '6px 10px' : '8px 12px',
            borderRadius: 999, border: `1px solid ${active ? brand.accent : brand.line}`,
            background: active ? `${brand.accent}1a` : brand.panel,
            color: brand.text, cursor: 'pointer', minWidth: compact ? 'auto' : 130,
          }}>
            <WxIcon kind={f.icon || 'unknown'} size={compact ? 22 : 28}/>
            <div style={{ textAlign: 'left', minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: brand.text, lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.label}</div>
              <div style={{ fontSize: 11, color: brand.textDim, fontVariantNumeric: 'tabular-nums', lineHeight: 1.2, marginTop: 1 }}>
                {f.temp ? `${f.temp}° · ` : ''}{f.cond || (f.region || '')}
              </div>
            </div>
          </button>
        );
      })}
      <button className="wx-tap" style={{
        flexShrink: 0, padding: '8px 14px', borderRadius: 999,
        border: `1px dashed ${brand.border}`, background: 'transparent', color: brand.textDim,
        display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer',
      }}>
        <Glyph.Plus s={14}/> Add
      </button>
    </div>
  );
}

export function SunArc({ brand, rise, set, dayLen }) {
  const progress = 0.62; // mid-afternoon placeholder; real time-bucket lands in next iteration
  const cx = 50 + progress * 200;
  const cy = 80 - Math.sin(progress * Math.PI) * 50;
  return (
    <div style={{ position: 'relative' }}>
      <svg viewBox="0 0 300 110" style={{ width: '100%', display: 'block' }}>
        <path d="M 50 85 Q 150 -15 250 85" stroke={brand.line} strokeWidth="2" strokeDasharray="3 3" fill="none"/>
        <path d={`M 50 85 Q ${50 + (cx-50)*1} ${85 - (85-cy)*2} ${cx} ${cy}`} stroke={brand.accent} strokeWidth="2" fill="none"/>
        <line x1="40" y1="85" x2="260" y2="85" stroke={brand.line} strokeWidth="1"/>
        <circle cx={cx} cy={cy} r="6" fill={brand.accent}/>
        <text x="50" y="103" fontSize="10" fill={brand.textDim} fontFamily="ui-monospace, monospace">{rise}</text>
        <text x="250" y="103" textAnchor="end" fontSize="10" fill={brand.textDim} fontFamily="ui-monospace, monospace">{set}</text>
      </svg>
      <div style={{ textAlign: 'center', fontSize: 12, color: brand.textDim, marginTop: -4 }}>Day length · <span style={{ color: brand.text, fontWeight: 600 }}>{dayLen}</span></div>
    </div>
  );
}
